import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { AppSettings } from '../settings/app.settings';
import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { SEOService } from '../shared/seo-service';


@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit{
  constructor(private meta:Meta, private title:Title, private translate:TranslateService, private hlang:HrefLang,private seoService:SEOService){}


  ngOnInit(){
    this.translate.get("META_TITLE_ABOUT").subscribe(text=>{
      this.title.setTitle(text);
    });
    this.translate.get("META_DESC_ABOUT").subscribe(text=>{
      let tag:MetaDefinition = {
        name:"description",
        content:text
      };
      this.meta.addTags([tag]);
    });
    let langs = [
      {lang:'es',text:'nosotros'},
      {lang:'en',text:'about-us'}/*,
      {lang:'fr',text:'a-propos-de-nous'},
      {lang:'it',text:'chi-siamo'},
    {lang:'de',text:'uber-uns'} */];
    langs.forEach(lang => {
      let hreflang_:HrefLangDefinition = {
        rel: "alternate",
        href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
        hreflang: `${lang.lang}`
      }
      this.hlang.addTags([hreflang_]);
    });
    this.seoService.createLinkForCanonicalURL('');
  }

}